module.exports = __webpack_public_path__ + "static/media/533131e3-85da-4c08-bd37-972bcf0bdddc-KjB6onytcCYKP8sxBtP5SxOAzM7cr6.8722049a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/533131e3-85da-4c08-bd37-972bcf0bdddc-KjB6onytcCYKP8sxBtP5SxOAzM7cr6.webp
// module id = 620
// module chunks = 0